import { render, staticRenderFns } from "./form-mail.vue?vue&type=template&id=37fb3204&scoped=true"
import script from "./form-mail.vue?vue&type=script&lang=js"
export * from "./form-mail.vue?vue&type=script&lang=js"
import style0 from "./form-mail.vue?vue&type=style&index=0&id=37fb3204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fb3204",
  null
  
)

export default component.exports